module.exports = __webpack_public_path__ + "img/04.7f69ad14.png";